

































import
  Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {Icon}
})
export default class NumberPad extends Vue {
  @Prop(Number) value!: number;
  @Prop() icon!: string;
  output = this.value.toString();
  result = 0;
  arr = ['0'];

  @Watch('output')
  onOutputChanged() {
    this.$emit('update:value', this.result);
  }

  inputContent(event: MouseEvent) {
    const button = event.target as HTMLButtonElement;
    const input = button.textContent as string;
    if (this.output.length >= 16) {return;}
    if (this.output === '0') {
      if ('0123456789'.indexOf(input) >= 0) {
        this.output = input;
      } else {
        this.output += input;
      }
      return;
    }
    if (this.output === '.') {
      this.output = '0.';
    }
    if (this.output === '+') {
      this.output = '';
    }
    if (this.output[this.output.length - 1] === ('+')) {
      if (input === '+') { return; }
    }
    if (this.output[this.output.length - 1] === ('.')) {
      if (input === '.') { return; }
    }
    for (let i = 0; i < Array.from(this.output).length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let addFlag = 0;
      if (this.output[i] === '+') {
        addFlag = i;  // 假如第一次 + 下标是 3
      }
      if (this.output[i] === '.') {
        if (input === '.' && this.output.indexOf('+') < 0) {
          return;
        }
      }
    }

    this.output += input;
  }

  add() {
    // 点击 + ，就将 output 的值增加到数组中，之前的不能被覆盖
    this.arr.push(this.output);
    this.output = '0';
  }

  done() {
    this.arr.push(this.output);
    for (let i = 0; i < this.arr.length; i++) {
      this.result += parseFloat(this.arr[i]);
    }
    this.$emit('submit', this.result);
    this.output = '0';
  }

  clear() {
    this.output = '';
  }

  clearOne() {
    this.output = this.output.slice(0, -1);
  }

}
